import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from "@material-ui/core/FormHelperText";

const extractValue = (value) => {
    return typeof value !== "undefined"
        ? !!value // It is a controlled component, cast the value.
        : undefined; // Leave it as an uncontrolled component.
};

/** @namespace props.controlBlock */
const FormCheck = ({label, label_exclaim, name, value, error, touched, onChange, onBlur, ...props}) => (
    <React.Fragment>
        <FormControlLabel
            control={(
                <Checkbox
                    color="primary"
                    id={name}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    checked={extractValue(value)}
                    {...props}
                />
            )}
            label={label}
        />
        {props.controlblock}

        {(error || touched) &&
        <FormHelperText error={touched && !!error}>
            {(touched && error) || label_exclaim}
        </FormHelperText>
        }
    </React.Fragment>
);

export default FormCheck;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/FormCheck.js